<template>
  <div style="postion:relative;width:100%">
    <div class="getHaibao">
      <van-tag
        round
        type="danger"
        v-on:click="showShare=true"
        color="#1baeae"
        style="padding:8px 25px 8px 20px"
      >立即分享</van-tag>
    </div>
    

    <van-overlay :show="showShare" @click="showShare = false">
      <div class="share">
        <div class="top">
            <img src="../assets/share.png" style="width:60%;text-align:right"/>
        </div>
        <div class="bottom">
          <div style="padding:20px"  v-if="user.user.is_share==1">
            <van-button type="primary" size="large" @click="getHaibao">产品宣传海报</van-button>
          </div>
          <div style="padding:20px">
            <van-button type="default" size="large">取消</van-button>
          </div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="show" @click="show = false">
      <img
        class="haibaoImg"
        :style="wOrh"
        style=" padding:8px; border:3px solid #888888"
        :src="img"
      />
    </van-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import { Tag } from "vant";
import { Overlay } from "vant";

Vue.use(Overlay);
Vue.use(Tag);
export default {
  name: "haibao",
  props: ["id", "module"],
  data() {
    return {
      user: { token: "", user: { is_share: 0, customer_type: 0 } },
      img: "",
      show: false,
      showShare: false,
      wOrh: "width:100%;",
    };
  },
  methods: {
    getHaibao() {
      //   this.$toast("功能开发中");

      this.$http
        .get(this.GLOBAL.API + "/s_user/share/getHaibao", {
          params: { id: this.id, module: this.module },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" },
        })
        .then((response) => {
          let data = response.body;
          if (data.code == 1) {
            this.show = true;
            this.img = this.GLOBAL.IMG + data.data;
          } else {
            this.$toast(data.msg);
          }
        });
    },
  },
  mounted() {
    if (window.screen.availHeight / window.screen.availWidth > 1.84) {
      this.wOrh = "width:100%;";
    } else {
      this.wOrh = "height:100%;";
    }
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  },
};
</script>
<style lang="scss" scoped>
.van-overlay {
  z-index: 999;
}
.getHaibao {
  position: fixed;
  bottom: 80px;
  z-index: 99;
  width: 150px;
  right: -20px;
  text-align: right;
}
.haibaoImg {
  //   position: absolute;
  z-index: 999;
  top: 10px;
  display: block;
  margin: 0 auto;
  //   width: 100%;
}
.share {
  width: 100%;
  height: 100%;
  .top {
    height: 70%;
    text-align: right;
  }
  .bottom {
    height: 30%;
    background-color: #fff;
  }
}
// .wrapper {
//   position: absolute;
//   top: 0;
//   z-index: 999;
//   display: block;
// }
</style>